





























































import { Component, Vue } from "vue-property-decorator";
import { WidgetsList as IWidgetsList } from "@/api/models/widgets-list";
import { getCurrentUserId } from "@/plugins/roles";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import WidgetTableItem from "@/components/integrations/WidgetTableItem.vue";
import { Widget as IWidget } from "@/api/models/widget";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";

@Component({ components: { DeleteMaterialModal, WidgetTableItem } })
export default class WidgetList extends Vue {
  widgetList: Array<IWidget> = [];
  offset: number = 0;
  limit: number = 30;
  itemCount: number | undefined = 0;
  gettingResult: boolean = false;
  widgetIdForDelete!: string | undefined;

  data() {
    return {
      widgetIdForDelete: undefined
    };
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get currentUserID() {
    return getCurrentUserId();
  }

  cancelRemove() {
    this.widgetIdForDelete = undefined;
  }

  deleteItem() {
    if (this.widgetIdForDelete)
      api.WidgetApi._delete(this.widgetIdForDelete).then(() => {
        this.widgetList = [];
        this.getWidgets();
        this.widgetIdForDelete = undefined;
        this.$bvModal.hide("modal-1");
        this.offset = 0;
      });
  }
  getRemItem(id: string) {
    this.widgetIdForDelete = id;
  }

  getWidgets(offset: number = 0) {
    this.gettingResult = true;
    api.WidgetApi.list(this.currentUserID, offset, this.limit)
      .then((res: { data: IWidgetsList }) => {
        this.itemCount = res.data.count;
        res.data.items.forEach(el => {
          this.widgetList.push(el);
        });
      })
      .finally(() => {
        this.gettingResult = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  showMore() {
    this.offset += this.limit;
    this.getWidgets(this.offset);
  }

  mounted() {
    this.getWidgets();
  }
}
